export default __webpack_public_path__ + "static/media/matt-palmer.e6c9b35a.jpg";